import React from 'react';
import { DateTime } from 'luxon';
import { Table } from 'antd';

const SAMPLE_USERS = [
  { id: 'user1', name: 'John Doe', type: 'user' },
  { id: 'user2', name: 'Jane Smith', type: 'user' },
];

const SAMPLE_EQUIPMENT = [
  { id: 'equipment1', name: 'Excavator', type: 'equipment' },
  { id: 'equipment2', name: 'Crane', type: 'equipment' },
];

const SAMPLE_COSTCODES = [
  { costcodeId: 'costcode1', costcode: { fullText: '100 - Concrete' } },
  { costcodeId: 'costcode2', costcode: { fullText: '200 - Electrical' } },
];

const sliceArray = (array) => array.slice(0, Math.min(2, array.length));

export default function TimeTrackingGridWizardPreview({
  selectedDate,
  selectedUsers,
  selectedEquipment,
  selectedCostcodes,
  currentStep,
}) {
  const formattedDate = selectedDate ? DateTime.fromISO(selectedDate).toFormat('cccc, MMM dd, yyyy') : 'No date selected';
  const tableUsers = selectedUsers?.length ? sliceArray(selectedUsers) : SAMPLE_USERS;
  const tableEquipment = selectedEquipment?.length ? sliceArray(selectedEquipment) : SAMPLE_EQUIPMENT;
  const tableCostcodes = selectedCostcodes?.length ? sliceArray(selectedCostcodes) : SAMPLE_COSTCODES;

  const tableRows = [
    { id: 'users', name: 'Users', type: 'user', isSummary: true },
    ...tableUsers,
    { id: 'equipment', name: 'Equipment', type: 'equipment', isSummary: true },
    ...tableEquipment,
  ];

  const tableColumns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 100,
    },
    ...tableCostcodes.map((costcode) => ({
      title: costcode.costcode.fullText,
      dataIndex: costcode.costcodeId,
      key: costcode.costcodeId,
      width: 100,
      render: (_, record) => {
        if (record.isSummary) return null;
        return (
          <div className="time-tracking-grid-wizard-preview-content-table-cell">
            <div className="time-tracking-grid-wizard-preview-content-table-cell-hours">0.00</div>
          </div>
        )
      },
    })),
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      width: 100,
      render: (_, record) => {
        if (record.isSummary) return null;
        return (
          <div className="time-tracking-grid-wizard-preview-content-table-cell-hours-total">0.00h</div>
        )
      },
    }
  ];
  return (
    <div className="time-tracking-grid-wizard-preview-container">
      <div className="time-tracking-grid-wizard-preview-title">Preview</div>
      <div className="time-tracking-grid-wizard-preview-content">
        <div className={`time-tracking-grid-wizard-preview-content-header ${currentStep === 0 ? 'current-step' : ''}`}>
          <div className="time-tracking-grid-wizard-preview-content-header-title">
            {formattedDate}
          </div>
        </div>
        <div>
          <Table
            columns={tableColumns}
            dataSource={tableRows}
            pagination={false}
            rowKey="id"
            size="small"
            rowClassName={(record) => {
              const classes = [];
              if (record.isSummary) classes.push('time-tracking-grid-wizard-preview-content-table-row-summary');
              if (currentStep === 2) classes.push('time-tracking-grid-wizard-preview-content-table-row-current-step');
              return classes.join(' ');
            }}
            className="time-tracking-grid-wizard-preview-content-table"
            onHeaderRow={() => ({
              className: currentStep === 1 ? 'time-tracking-grid-wizard-preview-content-table-header-row-current-step' : '',
            })}
          />
        </div>
        <div className="time-tracking-grid-wizard-preview-content-footer">
          <div className="time-tracking-grid-wizard-preview-content-footer-text">
            Sample preview - actual data will appear as you build your grid
          </div>
        </div>
      </div>
    </div>
  );
}